<template>
  <CollectionContainer :class="cn()">
    <section :class="cn('introduction')">
      <ShopifyImage
        :class="cn('image')"
        :src="collection.image.src"
        :alt="collection.image.alt || collection.title"
        ratio="7x5"
      />
      <h2 :class="cn('title')">{{ collection.title }}</h2>
      <div :class="cn('description')" v-html="collection.body_html"></div>

      <div :class="cn('cta')">
        Sign up for our email newsletter to be notified of the collections launch.
      </div>
      <NewsletterForm :class="cn('signup')" />
    </section>

    <!-- <CollectionSignup class="page-collection-instock__list" /> -->
  </CollectionContainer>
</template>

<script lang="ts" setup>
import { LiquidCollection } from '../../types/liquid'
import CollectionContainer from '../collection/CollectionContainer.vue'
// import CollectionSignup from '../collection/CollectionSignup.vue'
import ShopifyImage from '../shopify/ShopifyImage.vue'
import NewsletterForm from '../newsletter/NewsletterForm.vue'
import { bem } from '../../utils/classnames.ts'

const props = defineProps<{
  collection: LiquidCollection
}>()

console.log(props)

const cn = bem('page-collection-signup')
</script>

<style lang="scss">
@import '~styles/legacy.scss';
@import '~styles/base.scss';

.page-collection-signup {
  @include wrapper;
  width: 100%;

  &__introduction {
    margin: 0 auto;
    text-align: center;

    @include breakpoint('l+') {
      width: 580px;
      max-width: calc(100% - 400px);
    }
  }

  &__image {
    padding-bottom: 8px;
  }

  &__title {
    @include uppercase;
    @include type-xxl;
    padding-bottom: 4px;
  }

  &__description {
    @include type-xs;
    margin: auto;
    padding-bottom: 48px;

    @include breakpoint('l') {
      padding-bottom: 40px;
    }
  }

  &__cta {
    margin: 0 auto;
    padding-bottom: 8px;

    @include breakpoint('l') {
      width: 220px;
    }
  }

  &__signup {
    width: 320px;
    margin: 0 auto;

    @include breakpoint('l') {
      width: 220px;
    }
  }
}
</style>
